import styled from "styled-components";

export const FileStyles = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 120px;
  width: 100%;
  background: #fcfbfb;
  border: 1px solid #e0dede;

  &:hover {
    div.file-options {
      display: block;

      &:hover {
        cursor: pointer;
        div.file-options-content {
          display: flex;
        }
      }
    }
  }

  div.file-options-content {
    cursor: default;
    position: absolute;
    display: none;
    z-index: 3;
    top: 0px;
    right: -153px;
    background: #fcfbfb;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    border: 1px solid #a0a0a0;
    width: 182px;
    height: 130px;

    &:hover {
      display: flex;
    }
  }

  div.file-options {
    display: none;
    position: absolute;
    right: 6px;
    top: 6px;
    z-index: 2;
    animation-duration: 200ms;
    animation-delay: 0;
  }

  div.file-portrait {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
  }

  div.file-description {
    display: flex;
    align-items: center;
    height: 30px;
    border-top: 1px solid #e0dede;
    padding: 2px 20px 2px 20px;
    background: #ffffff;

    p {
      line-height: 12px;
      text-align: center;
    }
  }
`;
